import React, { useMemo } from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useGameIdFromRoute } from "../WithGameIdFromRoute";
import { useEditGameTask } from "@seabrookstudios/pitch2table";
import { EditTaskDialog } from "./EditTaskDialog";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Divider from "@mui/material/Divider";

/**
 * @param {Object} props
 * @param {import("@seabrookstudios/pitch2table-core").Task} props.item
 * @param {number} props.filteredIndex
 */
export const ListEntry = ({ item, filteredIndex }) => {
  const gameId = useGameIdFromRoute();
  const editTask = useEditGameTask(gameId, item.id);

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: item.id,
  });

  const isCompleted = item.status === "Done";

  const style = useMemo(
    () => ({
      transform: CSS.Transform.toString(transform),
      transition,
    }),
    [transform, transition]
  );

  const handleToggleComplete = async () => {
    await editTask.mutateAsync({
      name: undefined,
      order: undefined,
      status: item.status === "Done" ? "NotDone" : "Done",
    });
  };

  return (
    <>
      <ListItemButton
        ref={setNodeRef}
        style={style}
        sx={{
          opacity: isDragging ? 0.5 : isCompleted ? 0.7 : 1,
        }}
      >
        <ListItemIcon sx={{ minWidth: "40px" }}>
          {item.status !== "Done" && (
            <IconButton {...attributes} {...listeners} sx={{ cursor: "grab", padding: "4px" }}>
              <DragIndicatorIcon />
            </IconButton>
          )}
        </ListItemIcon>
        <ListItemIcon>
          <Checkbox checked={isCompleted} onChange={handleToggleComplete} disabled={editTask.isPending} />
        </ListItemIcon>
        <ListItemText primary={item.name} />
        <EditTaskDialog task={item} />
      </ListItemButton>
      {filteredIndex === 0 && <Divider />}
    </>
  );
};
